import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    List,
    ListItem,
    ListItemText,
    styled,
} from '@mui/material';

interface AlertItem {
    label: string;
}

interface CustomAlertModalProps {
    medwerkerDateIssueAlert: AlertItem[] | null;
    projectDateIssueAlert: AlertItem[] | null;
    handleClose: () => void;
}

const ModalContainer = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 550,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
}));

const ScrollableContent = styled(Box)({
    maxHeight: 200,
    overflowY: 'auto',
});

const CustomAlertModal: React.FC<CustomAlertModalProps> = ({
    medwerkerDateIssueAlert,
    projectDateIssueAlert,
    handleClose,
}) => {
    const [modalVisible, setModalVisible] = useState(true);

    const closeModal = () => {
        setModalVisible(false);
        handleClose();
    };

    return (
        <Modal
            open={modalVisible}
            onClose={() => setModalVisible(false)}
            aria-labelledby="custom-alert-modal"
            aria-describedby="custom-alert-description"
        >
            <ModalContainer>
                <Typography variant="h6" component="h2" gutterBottom>
                    {"Fauna Protect"}
                </Typography>

                <ScrollableContent>
                    {medwerkerDateIssueAlert && medwerkerDateIssueAlert.length > 0 && (
                        <Box mb={2}>
                            <Typography variant="body1" gutterBottom>
                                {'De einddatum van de taak ligt voorbij de vertrekdatum van de werknemer.'}
                            </Typography>
                            <List>
                                {medwerkerDateIssueAlert.map((item, index) => (
                                    <ListItem key={index} dense>
                                        <ListItemText primary={`• ${item.label}`} />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    )}

                    {projectDateIssueAlert && projectDateIssueAlert.length > 0 && (
                        <Box>
                            <Typography variant="body1" gutterBottom>
                                {'The task end date is beyond the project completion date.'}
                            </Typography>
                        </Box>
                    )}
                </ScrollableContent>

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                        variant="contained"
                        sx={{
                            bgcolor: '#4CAF50',
                            color: 'white',
                            '&:hover': { bgcolor: '#45a049' }
                        }}
                        onClick={closeModal}
                    >
                        {'OK'}
                    </Button>
                </Box>
            </ModalContainer>
        </Modal>
    );
};

export default CustomAlertModal;